export default "__VITE_ASSET__CM8bQVOq__"